import { computed, onMounted, ref, watch } from 'vue'
import { DOCS_PAGE } from '@/config'
import { useUserProfileStore } from '@/ContextTab/stores/userProfile'
import { usePublishedNewsStore } from '@/ContextTab/stores/newsSet/published/published'


const SOUNDS_PATH = '/sounds'
const SOUND_FILE_FORMAT = 'mp3'
const WARNING_TIMEOUT = 3000

export function useSoundNotifications() {

  const profileStore = useUserProfileStore()
  const publishedStore = usePublishedNewsStore()

  const soundNotifications = computed(() => profileStore.profile.soundNotifications ?? {
    enabled: true,
    sound: 'notification-1',
  })

  const instructionLink = DOCS_PAGE + `/c/%D0%BF%D0%B0%D0%BD%D0%B5%D0%BB%D1%8C-
%D0%B2%D1%8B%D0%BF%D1%83%D1%89%D0%B5%D0%BD%D0%BE/%D0%B7%D0%B2%D1%83%D0%BA%D0%BE%D0%B2%D1%8B%D0%B5-
%D1%83%D0%B2%D0%B5%D0%B4%D0%BE%D0%BC%D0%BB%D0%B5%D0%BD%D0%B8%D1%8F/`

  const showNoSoundAlert = ref(false)

  const audio = computed(() => createAudio(soundNotifications.value.sound))

  function createAudio(sound: string) {
    const audioUrl = new URL(`${SOUNDS_PATH}/${sound}.${SOUND_FILE_FORMAT}`, import.meta.url).href
    return new Audio(audioUrl)
  }

  async function playNotification(mute = false) {
    if (audio.value.muted !== mute) {
      audio.value.muted = mute
    }

    try {
      await audio.value.play()
    } catch (error) {
      if (error instanceof Error && error.name === 'NotAllowedError') {
        showNoSoundAlert.value = true

        const abortController = new AbortController()

        document.addEventListener('click', () => {
          showNoSoundAlert.value = false
          abortController.abort()
        }, { signal: abortController.signal })
      }
    }
  }

  onMounted(() => {
    if (soundNotifications.value.enabled) {
      setTimeout(async () => {
        await playNotification(true)
      }, WARNING_TIMEOUT)
    }
  })

  watch(() => publishedStore.urgentNewsSignal, async () => {
    if (soundNotifications.value.enabled) {
      await playNotification()
    }
  })

  return {
    showNoSoundAlert,
    instructionLink,
  }
}
